import { render } from "./EditPartnerSKU.vue?vue&type=template&id=2d5b2791"
import script from "./EditPartnerSKU.vue?vue&type=script&lang=js"
export * from "./EditPartnerSKU.vue?vue&type=script&lang=js"

import "./EditPartnerSKU.vue?vue&type=style&index=0&id=2d5b2791&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__